<template>
  <div id="distributorPage" class="page white" ref="distributorPage">
    <div class="bg-[#EFEFEF] p-0 h-full">
      <!-- Buy Order -->
      <OrderLicenseForm @handleSubmitOrder="handleSubmitOrder" />

      <!-- Content -->
      <div class="max-[1580px]:px-5! px-20">
        <div class="mx-auto max-w-[1515px] max-[1280px]:max-w-[1280px] flex justify-between items-center sticky top-0 bg-[#EFEFEF]">
          <h1 class="text-left text-md font-semibold py-4 text-base">{{ $t('licenseOrdering.yourOrders') }}</h1>
          <div
            v-if="activateTableData.length" id="licenseDistributorSearchBarWrapper">
            <ActivateSearchbar @input="handleSearchBarChange" />
          </div>
        </div>

        <div
          :class="[
            'bg-white border border-[#ebecf0] px-px overflow-y-scroll hide-scrollbar rounded-[8px] max-w-[1515px] max-[1280px]:max-w-[1280px]! mx-auto',
            {
              ' h-[calc(100vh-400px)]': !isTableEmpty && !isSearchResultEmpty,
              'h-auto': isTableEmpty || isSearchResultEmpty
            }
          ]">
          <activate-table
            :isTableEmpty="isTableEmpty"
            :searchResult="{ isEmpty: isSearchResultEmpty, keyword: searchVal }"
            :tableColumns="activateTableColumns"
            :tableData="filteredTableData"
            :noEntriesText="$t('licenseOrdering.noOrdersAvailable')"
            @expand="getLicenseCodes"
            @inputChange="updateComment"
            @inputEnter="updateComment"
            @buttonClick="deleteOrder"
            @sort="handleColumnSort"
            class="w-full bg-white text-jet border-spacing-0 border-separate">
          </activate-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./license-ordering.js"></script>
